import React from 'react';
import BankImportPage from './BankImportPage';

export default function CreditMutuelCHFPage() {
  return (
    <BankImportPage
      title="Credit Mutuel CHF Import"
      description="Import Credit Mutuel CHF transactions using the 7-field format."
      fieldLabels={['Date', 'Valeur', 'Libellé', 'Débit', 'Crédit', 'Solde', 'Dev']}
      listEndpoint="/api/credit-mutuel/chf"
      importEndpoint="/api/credit-mutuel/import/chf"
      bankId="CREDIT_MUTUEL"
      emptyText="No Credit Mutuel CHF records found."
      exchangeRate={{
        settingKey: 'credit_mutuel_chf_exchange_rate',
        label: '1 CHF = ? EUR',
        defaultValue: '1'
      }}
      hideAccountSelector
    />
  );
}
